import { createAction, handleActions, Action } from 'redux-actions'
// Name Spaced Action Types
export const TOGGLE_NAVBAR = 'Ui/TOGGLE_NAVBAR'
export const TOGGLE_ENDORSEMENT_DROPDOWN = 'Ui/TOGGLE_ENDORSEMENT_DROPDOWN'
export const TOGGLE_QUIZ_DROPDOWN = 'Ui/TOGGLE_QUIZ_DROPDOWN'
export const TOGGLE_ABOUT_DROPDOWN = 'Ui/TOGGLE_ABOUT_DROPDOWN'
export const TOGGLE_REGISTRATION_MODAL = 'Ui/TOGGLE_REGISTRATION_MODAL'
export const CHANGE_REGISTRATION_PAGE = 'Ui/CHANGE_REGISTRATION_PAGE'
export const RESET_REGISTRATION_PAGE = 'Ui/RESET_REGISTRATION_PAGE'
export const TOGGLE_RESET_PASS_MODAL = 'Ui/TOGGLE_RESET_PASS_MODAL'
export const TOGGLE_NOTIFICATION_MODAL = 'Ui/TOGGLE_NOTIFICATION_MODAL'
export const TOGGLE_NOTIFICATION_MODAL_TRUE = 'Ui/TOGGLE_NOTIFICATION_MODAL_TRUE'
export const TOGGLE_NOTIFICATION_MODAL_FALSE = 'Ui/TOGGLE_NOTIFICATION_MODAL_FALSE'
export const CHANGE_NOTIFICATION = 'Ui/CHANGE_NOTIFICATION'
export const TOGGLE_TOS_MODAL = 'Ui/TOGGLE_TOS_MODAL'
export const TOGGLE_SHORT_URL_MODAL = 'Ui/TOGGLE_SHORT_URL_MODAL'

export const actions = {
  TOGGLE_NAVBAR,
  TOGGLE_ENDORSEMENT_DROPDOWN,
  TOGGLE_QUIZ_DROPDOWN,
  TOGGLE_ABOUT_DROPDOWN,
  TOGGLE_REGISTRATION_MODAL,
  CHANGE_REGISTRATION_PAGE,
  RESET_REGISTRATION_PAGE,
  TOGGLE_RESET_PASS_MODAL,
  TOGGLE_NOTIFICATION_MODAL,
  TOGGLE_NOTIFICATION_MODAL_TRUE,
  TOGGLE_NOTIFICATION_MODAL_FALSE,
  CHANGE_NOTIFICATION,
  TOGGLE_TOS_MODAL,
  TOGGLE_SHORT_URL_MODAL
}

// createAction is a lib for creating FSAs
// see https://github.com/acdlite/flux-standard-action, for info in the flux standard action
type UiActionCreators = {
  toggleNavbar: () => Action<>,
  toggleEndorsementDropdown: () => Action<>,
  toggleQuizDropdown: () => Action<>,
  toggleAboutDropdown: () => Action<>,
  toggleRegistrationModal: () => Action<>,
  changeRegistrationPage: (number: number) => Action<number>,
  toggleResetPassModal: () => Action<>,
  toggleNotificationModal: () => Action<>,
  toggleNotificationModalTrue: () => Action<>,
  toggleNotificationModalFalse: () => Action<>,
  changeNotification: ({ header: string, text: string }) => Action<{
    header: string,
    text: string
  }>,
  toggleTosModal: () => Action<>,
  toggleShortUrlModal: () => Action
}

export const actionCreators: UiActionCreators = {
  toggleNavbar: createAction(TOGGLE_NAVBAR),
  toggleEndorsementDropdown: createAction(TOGGLE_ENDORSEMENT_DROPDOWN),
  toggleQuizDropdown: createAction(TOGGLE_QUIZ_DROPDOWN),
  toggleAboutDropdown: createAction(TOGGLE_ABOUT_DROPDOWN),
  toggleRegistrationModal: createAction(TOGGLE_REGISTRATION_MODAL),
  changeRegistrationPage: createAction(CHANGE_REGISTRATION_PAGE),
  toggleResetPassModal: createAction(TOGGLE_RESET_PASS_MODAL),
  toggleNotificationModal: createAction(TOGGLE_NOTIFICATION_MODAL),
  toggleNotificationModalTrue: createAction(TOGGLE_NOTIFICATION_MODAL_TRUE),
  toggleNotificationModalFalse: createAction(TOGGLE_NOTIFICATION_MODAL_FALSE),
  changeNotification: createAction(CHANGE_NOTIFICATION),
  toggleTosModal: createAction(TOGGLE_TOS_MODAL),
  toggleShortUrlModal: createAction(TOGGLE_SHORT_URL_MODAL)
}



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/uiActions.js